// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1fadO","search":"Settings_search__1FVUK","filter":"Settings_filter__I0PJW"};